<template>
  <div class="yunchanxinshen">
    <div v-show="!showQuestion" class="swipe-box swipe-box-explain">
      <div class="card">
        <van-tabs v-model="active">
          <van-tab title="孕产保健卡号" />
          <van-tab title="身份证号" />
        </van-tabs>
        <div class="num-input">
          <van-field v-if="active === 0" v-model="ygCard" type="number" :maxlength="13" placeholder="请输入孕产保健卡号" @keyup.enter.native="startBtn" />
          <van-field v-else v-model="patientSfz" :maxlength="18" placeholder="请输入身份证号" />
        </div>
        <!-- <h5 class="card-title"> 孕产保健卡号（阳光卡）</h5>
        <div class="card-num">
          <van-field ref="num0" v-model="num[0]" type="digit" class="ipnut-num" maxlength="1" @input="numInput(0)" />
          <van-field ref="num1" v-model="num[1]" type="digit" class="ipnut-num" maxlength="1" @input="numInput(1)" />
          <van-field ref="num2" v-model="num[2]" type="digit" class="ipnut-num" maxlength="1" @input="numInput(2)" />
          <van-field ref="num3" v-model="num[3]" type="digit" class="ipnut-num" maxlength="1" @input="numInput(3)" />
          <van-field ref="num4" v-model="num[4]" type="digit" class="ipnut-num" maxlength="1" @input="numInput(4)" />
          <van-field ref="num5" v-model="num[5]" type="digit" class="ipnut-num" maxlength="1" @input="numInput(5)" />
          <van-field ref="num6" v-model="num[6]" type="digit" class="ipnut-num" maxlength="1" @input="numInput(6)" />
          <van-field ref="num7" v-model="num[7]" type="digit" class="ipnut-num" maxlength="1" @input="numInput(7)" />
          <van-field ref="num8" v-model="num[8]" type="digit" class="ipnut-num" maxlength="1" @input="numInput(8)" />
          <van-field ref="num9" v-model="num[9]" type="digit" class="ipnut-num" maxlength="1" @input="numInput(9)" />
          <van-field ref="num10" v-model="num[10]" type="digit" class="ipnut-num" maxlength="1" @input="numInput(10)" />
          <van-field ref="num11" v-model="num[11]" type="digit" class="ipnut-num" maxlength="1" @input="numInput(11)" />
          <van-field ref="num12" v-model="num[12]" type="digit" class="ipnut-num" maxlength="1" @input="numInput(12)" />
        </div> -->
        <div class="card-tips"><span>* 请确认填写是否有误</span><van-icon name="checked" /></div>
      </div>
      <p class="top-text text-one">1.《孕产心身》快速筛查小程序仅用于孕产期人群的心身健康指标的快速筛查与识别使用，为自评问卷。主要评估孕产妇近2周来情绪心情状态。用时约3- 5分钟。</p>
      <p class="top-text text-blue">●指导语:回答时，只需要孕产妇本人根据自身近2周来实际的心理状态回答。</p>
      <div class="top-btn">
        <van-button type="info" :loading="startBtnLoading" round block loading-text="加载中..." @click="startBtn">开始答题</van-button>
      </div>
    </div>
    <template v-if="showQuestion && !isSumbit">
      <!-- :touchable="!showPicker && !showPickerChildbirth" -->
      <van-swipe
        ref="mySwipe"
        class="my-swipe"
        indicator-color="white"
        :touchable="false"
        :show-indicators="false"
        :loop="false"
        @change="swipeChage"
      >
        <van-swipe-item>
          <div class="swipe-box">
            <Box
              v-for="item in mList"
              :key="item.label"
              :num="item.label"
              :name="item.title"
            >
              <van-radio-group v-model="question[item.label]">
                <van-radio v-for="t in item.questioList" :key="t.num" :name="t.label">{{ t.label }}</van-radio>
              </van-radio-group>
            </Box>
          </div>
        </van-swipe-item>
        <van-swipe-item>
          <div class="swipe-box">
            <Box num="H1" name="你目前是否感染新冠病毒（COVID-19）">
              <van-radio-group v-model="question.H1">
                <van-radio name="未感染">未感染</van-radio>
                <van-radio name="首次感染">首次感染</van-radio>
                <van-radio name="第2次感染">第2次感染</van-radio>
                <van-radio name="第3次感染">第3次感染</van-radio>
                <van-radio name="第4次感染">第4次感染</van-radio>
                <van-radio name="第4次感染及以上">第4次感染及以上</van-radio>
              </van-radio-group>
            </Box>
            <Box v-if="question.H1 && question.H1 !== '未感染'" num="H2" name="目前为末次感染后">
              <van-radio-group v-model="question.H2" class="mt-20">
                <van-radio name="目前为感染后0-14天">目前为感染后0-14天</van-radio>
                <van-radio name="目前为感染后15-30天">目前为感染后15-30天</van-radio>
                <van-radio name="目前为感染后1月-3月">目前为感染后1月-3月</van-radio>
                <van-radio name="目前为感染后4月-6月">目前为感染后4月-6月</van-radio>
                <van-radio name="目前为感染后6月-1年">目前为感染后6月-1年</van-radio>
                <van-radio name="目前为感染后1年-2年">目前为感染后1年-2年</van-radio>
                <van-radio name="目前为感染后3年-5年">目前为感染后3年-5年</van-radio>
                <van-radio name="目前为感染后6年以上">目前为感染后6年以上</van-radio>
              </van-radio-group>
            </Box>
          </div>
        </van-swipe-item>
        <van-swipe-item>
          <div class="swipe-box">
            <Box num="A02" name="姓名">
              <van-field v-model="patientName" label="" placeholder="请输入姓名" />
            </Box>
            <Box num="A03" name="性别">
              <van-radio-group v-model="patientSex">
                <van-radio name="m">男</van-radio>
                <van-radio name="f">女</van-radio>
              </van-radio-group>
            </Box>
            <Box num="A04" name="联系方式（手机号）">
              <van-field v-model="patientPhone" label="" type="tel" maxlength="11" placeholder="请输入联系方式" />
            </Box>
            <Box num="A05" name="出生年月">
              <van-field
                readonly
                clickable
                :value="patientBirthday"
                placeholder="选择出生年月"
                @click="showPicker = true"
              />
              <van-popup
                v-model="showPicker"
                get-container="body"
                position="bottom"
              >
                <van-datetime-picker
                  v-model="currentDate"
                  type="year-month"
                  :min-date="minDate"
                  :max-date="maxDate"
                  @confirm="onConfirm"
                  @cancel="showPicker = false"
                />
              </van-popup>
            </Box>
            <Box num="A06" name="目前体重（kg）">
              <van-field
                v-model="patientWeight"
                label=""
                type="digit"
                placeholder="请输入目前体重"
                @blur="weightBlur(patientWeight)"
              />
            </Box>
            <Box num="A07" name="第几次筛查">
              <van-radio-group v-model="pregnancyTime">
                <van-radio name="1">首次</van-radio>
                <van-radio name="2">第2次</van-radio>
                <van-radio name="3">第3次</van-radio>
                <van-radio name="4">第4次</van-radio>
                <van-radio name="5">第5次及5次以上</van-radio>
              </van-radio-group>
            </Box>
          </div>
        </van-swipe-item>
        <van-swipe-item v-show="pregnancyTime === '1'">
          <div class="swipe-box">
            <Box num="A08" name="民族">
              <van-radio-group v-model="question.A08">
                <van-radio name="汉">汉</van-radio>
                <van-radio name="0">其他</van-radio>
              </van-radio-group>
              <van-field v-model="nation" label="" placeholder="请输入民族" />
            </Box>
            <Box num="A09" name="独生子女">
              <van-radio-group v-model="question.A09">
                <van-radio name="是">是</van-radio>
                <van-radio name="否">否</van-radio>
              </van-radio-group>
            </Box>
            <Box num="A10" name="本地居民（指苏州大市范围）">
              <van-radio-group v-model="question.A10">
                <van-radio name="是">是</van-radio>
                <van-radio name="否">否</van-radio>
              </van-radio-group>
            </Box>
            <Box num="A11" name="居住区域">
              <van-radio-group v-model="question.A11">
                <van-radio name="城市">城市</van-radio>
                <van-radio name="乡镇">乡镇</van-radio>
                <van-radio name="农村">农村</van-radio>
              </van-radio-group>
            </Box>
            <Box num="A12" name="居住条件">
              <van-radio-group v-model="question.A12">
                <van-radio name="有房">有房</van-radio>
                <van-radio name="租住">租住</van-radio>
                <van-radio name="其它">其它</van-radio>
              </van-radio-group>
            </Box>
            <Box num="A13" name="医疗费用支付方式">
              <van-radio-group v-model="question.A13">
                <van-radio name="医疗保险">医疗保险</van-radio>
                <van-radio name="商业保险">商业保险</van-radio>
                <van-radio name="自费">自费</van-radio>
                <van-radio name="其他">其他</van-radio>
              </van-radio-group>
            </Box>
            <Box num="A14" name="受教育程度">
              <van-radio-group v-model="question.A14">
                <van-radio name="小学">小学</van-radio>
                <van-radio name="初中">初中</van-radio>
                <van-radio name="中专/高中">中专/高中</van-radio>
                <van-radio name="大专/高职">大专/高职</van-radio>
                <van-radio name="大学本科">大学本科</van-radio>
                <van-radio name="硕士">硕士</van-radio>
                <van-radio name="博士">博士</van-radio>
                <van-radio name="文盲">文盲</van-radio>
              </van-radio-group>
            </Box>
            <Box num="A15" name="身高（cm）">
              <van-field
                v-model="question.A15"
                label=""
                type="number"
                placeholder="请输入身高"
                @blur="heightBlur(question.A15)"
              />
            </Box>
            <Box num="A16" name="孕前体重（kg）">
              <van-field
                v-model="question.A16"
                label=""
                type="digit"
                placeholder="请输入孕前体重"
                @blur="weightBlur(question.A16)"
              />
            </Box>
          </div>
        </van-swipe-item>
        <van-swipe-item>
          <div class="swipe-box">
            <Box num="B01" name="这是您第几次怀孕？">
              <van-radio-group v-model="question.B01">
                <van-radio name="第1次">第1次</van-radio>
                <van-radio name="第2次">第2次</van-radio>
                <van-radio name="第3次">第3次</van-radio>
                <van-radio name="≥4次">≥4次</van-radio>
              </van-radio-group>
            </Box>
            <Box num="B02" name="这是您的第几个宝宝？">
              <van-radio-group v-model="question.B02">
                <van-radio name="1胎单胎">1胎单胎</van-radio>
                <van-radio name="1胎双胎">1胎双胎</van-radio>
                <van-radio name="2胎单胎">2胎单胎</van-radio>
                <van-radio name="2胎双胎">2胎双胎</van-radio>
                <van-radio name="3胎及以上">3胎及以上</van-radio>
              </van-radio-group>
            </Box>
            <Box num="B03" name="受孕方式">
              <van-radio-group v-model="question.B03">
                <van-radio name="人工受孕">人工受孕</van-radio>
                <van-radio name="自然受孕（有计划）">自然受孕（有计划）</van-radio>
                <van-radio name="自然受孕（意外、无计划）">自然受孕（意外、无计划）</van-radio>
              </van-radio-group>
            </Box>
            <Box num="B04" name="本次怀孕有无保胎">
              <van-radio-group v-model="question.B04">
                <van-radio name="无">无</van-radio>
                <van-radio name="有">有</van-radio>
              </van-radio-group>
            </Box>
            <Box num="B04A" name="您本次妊娠是否有其他合并症（多选）">
              <van-checkbox-group v-model="question.B04A">
                <van-checkbox name="无" :disabled="!!question.B04A.length && !checkedShow">无</van-checkbox>
                <van-checkbox name="高血压" :disabled="!!question.B04A.length && checkedShow">高血压</van-checkbox>
                <van-checkbox name="糖尿病" :disabled="!!question.B04A.length && checkedShow">糖尿病</van-checkbox>
                <van-checkbox name="其他" :disabled="!!question.B04A.length && checkedShow">其他</van-checkbox>
              </van-checkbox-group>
            </Box>
          </div>
        </van-swipe-item>
        <van-swipe-item>
          <div class="swipe-box">
            <Box num="B05" name="目前孕产期">
              <van-radio-group v-model="question.B05">
                <span class="maternity-title">孕期</span>
                <van-radio name="0-12周">0-12周</van-radio>
                <van-radio name="13-20周">13-20周</van-radio>
                <van-radio name="21-27周">21-27周</van-radio>
                <van-radio name="28-36周">28-36周</van-radio>
                <van-radio name="37-44周">37-44周</van-radio>
                <span class="maternity-title">产后</span>
                <van-radio name="0-1周">0-1周</van-radio>
                <van-radio name="2-4周">2-4周</van-radio>
                <van-radio name="1-3月">1-3月</van-radio>
                <van-radio name="4-6月">4-6月</van-radio>
                <van-radio name="7-9月">7-9月</van-radio>
                <van-radio name="10-12月">10-12月</van-radio>
              </van-radio-group>
            </Box>
          </div>
        </van-swipe-item>
        <van-swipe-item v-show="pregnancyType">
          <div class="swipe-box">
            <Box num="B06" name="分娩日期">
              <van-field
                readonly
                clickable
                :value="question.B06"
                placeholder="选择出生年月"
                @click="showPickerChildbirth = true"
              />
              <van-popup
                v-model="showPickerChildbirth"
                get-container="body"
                position="bottom"
              >
                <van-datetime-picker
                  v-model="currentDateFm"
                  type="date"
                  title="选择年月日"
                  :min-date="minDate"
                  :max-date="maxDate"
                  @confirm="onConfirmChildbirth"
                  @cancel="showPickerChildbirth = false"
                />
              </van-popup>
            </Box>
            <Box num="B07" name="新生儿体重（g）">
              <van-field
                v-model="question.B07"
                label=""
                type="digit"
                placeholder="请输入新生儿体重"
                @blur="weightMinBlur(question.B07)"
              />
            </Box>
            <Box num="B08" name="新生儿身长（cm）">
              <van-field
                v-model="question.B08"
                label=""
                type="number"
                placeholder="请输入新生儿身长"
                @blur="heightMinBlur(question.B08)"
              />
            </Box>
            <Box num="B09" name="分娩方式">
              <van-radio-group v-model="question.B09">
                <van-radio name="剖宫">剖宫</van-radio>
                <van-radio name="顺产">顺产</van-radio>
              </van-radio-group>
            </Box>
            <Box num="B10" name="新生儿性别">
              <van-radio-group v-model="question.B10">
                <van-radio name="男">男</van-radio>
                <van-radio name="女">女</van-radio>
              </van-radio-group>
            </Box>
            <Box num="B11" name="无痛分娩">
              <van-radio-group v-model="question.B11">
                <van-radio name="是">是</van-radio>
                <van-radio name="否">否</van-radio>
              </van-radio-group>
            </Box>
            <Box num="B12" name="新生儿健康状态">
              <van-radio-group v-model="question.B12">
                <van-radio name="良好">良好</van-radio>
                <van-radio name="一般">一般</van-radio>
                <van-radio name="较差">较差</van-radio>
                <van-radio name="差">差</van-radio>
              </van-radio-group>
            </Box>
            <Box num="B13" name="喂养方式">
              <van-radio-group v-model="question.B13">
                <van-radio name="母乳">母乳</van-radio>
                <van-radio name="人工">人工</van-radio>
              </van-radio-group>
            </Box>
            <Box num="B14" name="分娩孕周">
              <van-radio-group v-model="question.B14">
                <van-radio name="27-30周">27-30周</van-radio>
                <van-radio name="31-36周">31-36周</van-radio>
                <van-radio name="37-40周">37-40周</van-radio>
                <van-radio name="40-44周">40-44周</van-radio>
                <van-radio name="45周以上">45周以上</van-radio>
              </van-radio-group>
            </Box>
            <Box num="B15" name="孕妇产后照料者">
              <van-checkbox-group v-model="question.B15" :max="3">
                <van-checkbox shape="square" name="丈夫">丈夫 <span v-if="question.B15[0] === '丈夫'" class="zhu">主</span></van-checkbox>
                <van-checkbox shape="square" name="父母">父母 <span v-if="question.B15[0] === '父母'" class="zhu">主</span></van-checkbox>
                <van-checkbox shape="square" name="公婆">公婆 <span v-if="question.B15[0] === '公婆'" class="zhu">主</span></van-checkbox>
                <van-checkbox shape="square" name="保姆">保姆 <span v-if="question.B15[0] === '保姆'" class="zhu">主</span></van-checkbox>
                <van-checkbox shape="square" name="商业机构">商业机构 <span v-if="question.B15[0] === '商业机构'" class="zhu">主</span></van-checkbox>
                <van-checkbox shape="square" name="无人照料">无人照料 <span v-if="question.B15[0] === '无人照料'" class="zhu">主</span></van-checkbox>
              </van-checkbox-group>
            </Box>
          </div>
        </van-swipe-item>
        <van-swipe-item v-show="pregnancyType">
          <div class="swipe-box">
            <Box num="B16" name="分娩医院">
              <van-radio-group v-model="question.B16">
                <van-radio name="市立医院（本部，母子中心）">市立医院（本部，母子中心）</van-radio>
                <van-radio name="市立医院（东区）">市立医院（东区）</van-radio>
                <van-radio name="市立医院（北区）">市立医院（北区）</van-radio>
                <van-radio name="苏大附一院">苏大附一院</van-radio>
                <van-radio name="苏大附二院">苏大附二院</van-radio>
                <van-radio name="苏州科技城医院">苏州科技城医院</van-radio>
                <van-radio name="苏州明基医院">苏州明基医院</van-radio>
                <van-radio name="苏州九龙医院">苏州九龙医院</van-radio>
                <van-radio name="吴中区人民医院">吴中区人民医院</van-radio>
                <van-radio name="相城区人民医院">相城区人民医院</van-radio>
                <van-radio name="吴江区人民医院">吴江区人民医院</van-radio>
                <van-radio name="昆山市人民医院">昆山市人民医院</van-radio>
                <van-radio name="常熟市人民医院">常熟市人民医院</van-radio>
                <van-radio name="张家港市人民医院">张家港市人民医院</van-radio>
                <van-radio name="0">其它医院</van-radio>
              </van-radio-group>
              <van-field v-model="hospitalName" class="field-border" placeholder="请输入医院名称" />
            </Box>
          </div>
        </van-swipe-item>
        <!-- d1 d2 d9 -->
        <van-swipe-item>
          <div class="swipe-box">
            <template v-for="(item, index) in dList">
              <Box
                v-if="index < 2 || index === 8"
                :key="item.label"
                :num="item.label"
                :name="item.title"
              >
                <van-radio-group v-model="question[item.label]">
                  <van-radio v-for="t in item.questioList" :key="t.num" :name="t.num">{{ t.label }}</van-radio>
                </van-radio-group>
              </Box>
            </template>
            <van-button v-show="showDEList === 0" type="info" :loading="btnLoading" loading-text="提交中..." block round @click="sumbit">立即提交</van-button>
          </div>
        </van-swipe-item>
        <!-- g1-g7 m2 -->
        <van-swipe-item v-show="showDEList">
          <div class="swipe-box">
            <Box
              v-for="item in gList"
              :key="item.label"
              :num="item.label"
              :name="item.title"
            >
              <van-radio-group v-model="question[item.label]">
                <van-radio v-for="t in item.questioList" :key="t.num" :name="t.num">{{ t.label }}</van-radio>
              </van-radio-group>
            </Box>
          </div>
        </van-swipe-item>
        <!-- d3-8 -->
        <van-swipe-item v-show="showDEList">
          <div class="swipe-box">
            <template v-for="(item, index) in dList">
              <Box
                v-if="index >1 && index < 8"
                :key="item.label"
                :num="item.label"
                :name="item.title"
              >
                <van-radio-group v-model="question[item.label]">
                  <van-radio v-for="t in item.questioList" :key="t.num" :name="t.num">{{ t.label }}</van-radio>
                </van-radio-group>
              </Box>
            </template>
          </div>
        </van-swipe-item>
        <!-- e1-e10 -->
        <van-swipe-item v-show="showDEList">
          <div class="swipe-box">
            <Box
              v-for="item in eList"
              :key="item.label"
              :num="item.label"
              :name="item.title"
            >
              <van-radio-group v-model="question[item.label]">
                <van-radio v-for="t in item.questioList" :key="t.num" :name="t.num">{{ t.label }}</van-radio>
              </van-radio-group>
            </Box>
            <van-button type="info" block round :loading="btnLoading" loading-text="提交中..." @click="sumbit">立即提交</van-button>
          </div>
        </van-swipe-item>
      </van-swipe>
      <div class="page-btn">
        <div class="btn-up" @click="upPage"><img src="@/assets/images/yunchanxinshen/up_icon.png" alt=""></div>
        <div class="btn-down" @click="downPage"><img src="@/assets/images/yunchanxinshen/down_icon.png" alt=""></div>
      </div>
    </template>
    <div v-if="isSumbit" class="swipe-box">
      <div class="fraction-box">
        <div>问卷得分</div>
        <div class="num">PHQ:{{ phq }}</div>
        <div class="num">EPDS:{{ epds }}</div>
        <div class="san" :class="`san${grade}`" />
      </div>
      <div class="fraction-qr">
        <p>{{ pushMsg }}</p>
        <img v-if="grade > 1" class="pic" src="@/assets/images/ycsx_qr.jpg" alt="">
        <p v-if="grade > 1">请联系工作人员获得登录名与密码</p>
      </div>
      <div class="bom-btn">
        <van-button type="info" block round @click="goHome">返回首页</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import Box from './formBox.vue'
import { eList, dList, gList, mList } from './question'
export default {
  name: 'Yunchanxinshen',
  components: {
    Box
  },
  data() {
    return {
      active: 0,
      appletsId: '', // 微信唯一标识
      num: [3, 2, 0, 5], // 卡号form
      ygCard: '3205', // 卡号
      patientSfz: '', // 身份证号
      patientName: '', // 姓名
      patientSex: 'f', // 性别 m-男 f-女
      patientPhone: '', // 手机号码
      patientBirthday: '', // 出生年月
      patientWeight: '', // 体重
      pregnancyTime: '1', // 第几次筛查 1-首次 2-第2次 3-第3次 4-第4次 5-第5次及以上
      // pregnancyType: '', // 类型-孕期产后
      content: '', // 问卷内容(题与答案)
      showQuestion: false,
      startBtnLoading: false,
      showStartBtn: false,
      showPicker: false,
      showPickerChildbirth: false,
      minDate: new Date(moment('1900/01/01')),
      maxDate: new Date(),
      currentDate: new Date(),
      currentDateFm: new Date(),
      isSumbit: false,
      question: { A08: '', A09: '', A10: '', A11: '', A12: '', A13: '', A14: '', A15: '', A16: '', B01: '', B02: '', B03: '', B04: '', B04A: [], B05: '', B06: '', B07: '', B08: '', B09: '', B10: '', B11: '', B12: '', B13: '', B14: '', B15: [], B16: '', D1: '', D2: '', M1: '', M2: '', M3: '', M4: '', M5: '', M6: '', G1: '', G2: '', G3: '', G4: '', G5: '', G6: '', G7: '', H1: '', H2: '', D3: '', D4: '', D5: '', D6: '', D7: '', D8: '', D9: '', E01: '', E02: '', E03: '', E04: '', E05: '', E06: '', E07: '', E08: '', E09: '', E10: '' },
      nation: '', // 民族
      hospitalName: '', // 医院名称
      typeList: ['没有', '有几天', '一半时间以上', '几乎天天'],
      pageIndex: 0,
      btnLoading: false,
      pushMsg: '', // 提示消息
      grade: '', // 等级
      score: '', // 得分
      epds: '', // 得分
      phq: '', // 得分
      eList,
      dList,
      gList,
      mList
    }
  },
  computed: {
    pregnancyType() {
      const val = this.question.B05
      const arr1 = ['0-12周', '13-20周', '21-27周', '28-36周', '37-44周']
      const arr2 = ['0-1周', '2-4周', '1-3月', '4-6月', '7-9月', '10-12月']
      let str = 0
      if (arr1.includes(val)) {
        str = 0
      } else if (arr2.includes(val)) {
        str = 1
      }
      return str
    },
    maxPageSize() {
      let num = 5
      if (this.pregnancyTime === '1') {
        num += 1
      }
      if (this.pregnancyType) {
        num += 2
      }
      if (this.showDEList) {
        num += 3
      }
      return num
    },
    /* ygCard() {
      return this.num.join('')
    }, */
    showDEList() {
      const a = this.question.D1
      const b = this.question.D2
      const c = this.question.D9
      if (a === '' || b === '' || c === '') {
        return ''
      } else {
        return Number(a) + Number(b) + Number(c)
      }
    },
    sumScore() {
      const a = this.question.D1 || 0
      const b = this.question.D2 || 0
      return Number(a) + Number(b)
    },
    checkedShow() {
      return this.question.B04A.includes('无')
    }
  },
  created() {
    this.appletsId = localStorage.getItem('openId')
  },
  mounted() {},
  methods: {
    startBtn() {
      if (!this.active && this.ygCard.length < 13) {
        this.$toast({
          message: '请输入完整卡号'
        })
        return
      }

      const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      if (this.active && !reg.test(this.patientSfz)) {
        this.$toast.fail('身份证号格式错误')
        return
      }

      const params = {
        appletsId: this.appletsId
      }
      if (this.active) {
        params.patientSfz = this.patientSfz
      } else {
        params.ygCard = this.ygCard
      }
      this.startBtnLoading = true
      this.$Apis.getPregnancyQuestionnaireInfo(params).then(res => {
        if (res.code === 200) {
          this.patientBirthday = res.data.patientBirthday
          this.patientName = res.data.patientName
          this.patientPhone = res.data.patientPhone
          this.patientSex = res.data.patientSex || 'f'
          // this.$refs.mySwipe.next()
        } else {
          this.$dialog.alert({
            title: '提示',
            message: res.message
          }).then(() => {})
        }
        this.startBtnLoading = false
        this.showQuestion = true
      })
    },
    onConfirm(val) {
      this.patientBirthday = moment(val).format('yyyy-MM')
      this.showPicker = false
    },
    onConfirmChildbirth(val) {
      this.question.B06 = moment(val).format('yyyy-MM-DD')
      this.showPickerChildbirth = false
    },
    numInput(name) {
      if (this.num[name]) {
        if (name === 12) return
        this.$refs[`num${name + 1}`].focus()
      } else {
        // if (name === 0) return
        // this.$refs[`num${name - 1}`].focus()
      }
    },
    weightBlur(val) {
      if (val && (val < 35 || val > 100)) {
        this.$dialog.alert({
          title: '提示',
          message: '体重正常范围在35kg~100kg内，请确认填写是否有误'
        }).then(() => {})
      }
    },
    heightBlur(val) {
      if (val && (val < 140 || val > 200)) {
        this.$dialog.alert({
          title: '提示',
          message: '身高正常范围在140~200cm内，请确认填写是否有误'
        }).then(() => {})
      }
    },
    weightMinBlur(val) {
      if (val && (val < 1000 || val > 7000)) {
        this.$dialog.alert({
          title: '提示',
          message: '体重正常范围在1000~7000g内，请确认填写是否有误'
        }).then(() => {})
      }
    },
    heightMinBlur(val) {
      if (val && (val < 20 || val > 75)) {
        this.$dialog.alert({
          title: '提示',
          message: '身长正常范围在20-75cm内，请确认填写是否有误'
        }).then(() => {})
      }
    },
    sumbit() {
      // console.log(JSON.stringify(this.question))
      const question = { ...this.question }
      const jiBenList = ['A08', 'A09', 'A10', 'A11', 'A12', 'A13', 'A14', 'A15', 'A16']
      const list = ['B07', 'B08', 'H2']
      const chanFuList = ['B06', 'B09', 'B10', 'B11', 'B12', 'B13', 'B14', 'B15', 'B16']
      const deList = ['G1', 'G2', 'G3', 'G4', 'G5', 'G6', 'G7', 'D3', 'D4', 'D5', 'D6', 'D7', 'D8', 'E01', 'E02', 'E03', 'E04', 'E05', 'E06', 'E07', 'E08', 'E09', 'E10']
      const arr = []
      if (!this.patientName) {
        arr.push('A02姓名')
      }
      if (!this.patientPhone) {
        arr.push('A04手机号码')
      }
      if (!this.patientBirthday) {
        arr.push('A05出生年月')
      }
      if (!this.patientWeight) {
        arr.push('A06目前体重')
      }
      Object.keys(question).forEach(k => {
        if (!question[k] && question[k] === '' && question[k] !== 0 && !list.includes(k)) {
          if (
            !((this.pregnancyTime !== '1' && jiBenList.includes(k)) ||
            (!this.showDEList && deList.includes(k)) ||
            (!this.pregnancyType && chanFuList.includes(k)))
          ) {
            arr.push(k)
          }
        }
      })
      if (question.B04A.length === 0) {
        arr.push('B04A')
      }
      if (question.B15.length === 0 && this.pregnancyType) {
        arr.push('B15')
      }
      if (!!question.H1 && question.H1 !== '未感染' && !question.H2) {
        arr.push('H2')
      }
      // console.log(arr)
      if (arr.length) {
        this.$dialog.alert({
          title: '提示',
          message: arr.join(',') + '未填写,请将问卷填写完整'
        }).then(() => {})
        return
      }
      if (question.A08 === '0') {
        question.A08 = this.nation
      }
      if (question.B16 === '0') {
        question.B16 = this.hospitalName
      }
      const allList = [...this.gList, ...this.dList, ...this.eList]
      const newArr = []
      const dFilterList = ['D1', 'D2', 'D9']
      allList.forEach(item => {
        const score = this.question[item.label]
        if (!this.showDEList && !dFilterList.includes(item.label)) {
          question[item.label] = ''
          newArr.push({
            ref: item.label,
            title: item.title,
            answer: '',
            score: ''
          })
        } else {
          question[item.label] = this.scoreQuestion(item)
          newArr.push({
            ref: item.label,
            title: item.title,
            answer: score !== '' ? item.questioList[score].label : '',
            score
          })
        }
      })
      // console.log(question)
      const content = JSON.stringify(question)
      const beforeList = this.mList.map(item => {
        const obj = {
          ref: item.label,
          title: item.title,
          answer: this.question[item.label]
        }
        return obj
      })

      const detailsList = [...beforeList, ...newArr]

      const params = {
        appletsId: this.appletsId,
        // ygCard: this.ygCard, // 卡号
        patientName: this.patientName, // 姓名
        patientSex: this.patientSex, // 性别 m-男 f-女
        patientPhone: this.patientPhone, // 手机号码
        patientBirthday: this.patientBirthday, // 出生年月
        patientWeight: this.patientWeight, // 体重
        pregnancyTime: this.pregnancyTime, // 第几次筛查 1-首次 2-第2次 3-第3次 4-第4次 5-第5次及以上
        pregnancyType: this.pregnancyType ? '产后' : '孕期', // 类型-孕期产后
        // sumScore: this.sumScore, // 问卷总分
        details: detailsList,
        content // 问卷内容(题与答案)
      }
      if (this.active) {
        params.patientSfz = this.patientSfz
      } else {
        params.ygCard = this.ygCard
      }
      console.log(params)
      this.btnLoading = true
      this.$Apis.addPregnancyQuestionnaire(params).then(res => {
        this.btnLoading = false
        if (res.code === 200) {
          this.isSumbit = true
          this.pushMsg = res.data.pushMsg
          this.grade = res.data.grade
          this.score = res.data.score
          this.phq = res.data.phq
          this.epds = res.data.epds
          this.$toast({
            message: res.message,
            duration: 1000
          })
        } else {
          this.$toast(res.message || '提交失败！')
        }
      }).catch(() => {
        this.btnLoading = false
      })
    },
    scoreQuestion(item) {
      const val = this.question[item.label]
      return val !== '' ? `${item.questioList[val].label}(${val})` : ''
    },
    upPage() {
      this.$refs.mySwipe.prev()
    },
    downPage() {
      if (this.pageIndex === this.maxPageSize) return
      this.$refs.mySwipe.next()
    },
    swipeChage(index) {
      this.pageIndex = index
    },
    goHome() {
      this.$router.replace('/')
    }
  }
}
</script>
<style lang="less" scoped>
.yunchanxinshen{
  /deep/ .van-tab{
    color: #C6D9FF;
  }
  /deep/ .van-tabs__nav {
    background-color: transparent;
  }
  /deep/ .van-tab--active{
    font-size: 18px;
    color: #fff;
  }
  /deep/ .van-tabs__line{
    background-color: #fff;
    height: 2px;
  }
  .num-input{
    margin: 20px 0 20px;
  }
  .swipe-box{
    height: calc(100vh - 40px);
    // margin: 10px;
    // background: #fff;
    border-radius: 10px;
    padding: 10px;
    overflow-y: auto;
    /deep/ .van-field{
      border: 1px solid #eee;
      border-radius: 4px;
    }
    /deep/ .van-cell{
      padding: 8px 10px;
    }
    /deep/.van-radio-group,
    .van-checkbox-group{
      &>div{
        padding: 10px 0;
        position: relative;
        &::after{
          content: '';
          display: block;
          position: absolute;
          bottom: 0;
          right: 0;
          height: 1px;
          width: calc(100% - 26px);
          background: #eee;
        }
        &:last-child {
          &::after{
            height: 0
          }
        }
      }
      .van-radio__label{
        margin-left: 20px;
      }
    }
    .top-text{
      font-size: 16px;
      line-height: 26px;
      margin: 0 35px 5px;
    }
    .text-one{
      margin-top: 80px;
      margin-bottom: 40px;
    }
    .text-blue{
      color: #3F7EFF;
    }
    .top-btn{
      width: 80%;
      margin: 80px auto 0;
      button{
        color: #fff;
        // font-size: 20px;
      }
    }
    .zhu{
      background: #FA6362;
      color: #fff;
      font-size: 12px;
      line-height: 18px;
      display: inline-block;
      padding: 0 10px;
      border-radius: 10px;
    }
  }
  .swipe-box-explain{
    background: url(~@/assets/images/yunchanxinshen/explain_bj.png) no-repeat;
    background-size: 100% auto;
  }
  // 说明页
  .card{
    position: relative;
    .card-title{
      margin-top: 20px;
      font-size: 16px;
      line-height: 2;
      margin-bottom: 10px;
      text-align: center;
      color: #fff;
      background: url(~@/assets/images/yunchanxinshen/title_bj.png) no-repeat;
      background-position: 0 center;
      background-size: 100% auto;
    }
    .card-num{
      display: flex;
      justify-content: space-between;
      margin: 0 10px 10px;
      .ipnut-num{
        // width: 22px;
        margin-right: 2px;
        height: 30px;
        display: inline-block;
        border: 1px solid #ccc;
        padding: 3px 6px;
        &:last-child{
          margin-right: 0;
        }
      }
    }
    .card-tips{
      margin: 0 0 20px 10px;
      line-height: 1.5;
      span{
        color: #FF9035;
      }
      /deep/.van-icon{
        margin-left: 4px;
        color: #4DBB88;
      }
    }
  }

  .field-border{
    border: 1px solid #ccc;
  }
  /deep/.from-item{
    .van-radio,
    .van-checkbox{
      margin-bottom: 11px;
      .van-checkbox__label{
        margin-left: 20px;
      }
    }
    &:last-child{
      margin-bottom: 0;
    }
  }
  .maternity-title{
    color: #217FFF;
    line-height: 28px;
    margin-left: 30px;
  }
  .fraction-box{
    // background: url('~@/assets/images/yunchanxinshen/fraction.png') no-repeat;
    background: url('~@/assets/images/yunchanxinshen/fraction_new.png') no-repeat;
    background-size: cover;
    box-sizing: border-box;
    padding-top: 120px;
    height: 190px;
    margin: 10px 30px 0;
    text-align: center;
    margin-bottom: 30px;
    color: #999999;
    font-size: 15px;
    line-height: 24px;
    position: relative;
    .num {
      font-size: 18px;
      line-height: 1.5;
      color: #333333;
      font-weight: bold;
    }
    .san{
      position: absolute;
      bottom: 10px;
      left: 50%;
      margin-left: 0px;
      width: 110px;
      height: 10px;
      transform: rotate(-180deg);
      transform-origin:left center;
      transition: transform .5s;
      &::after{
        content: '';
        display: inline-block;
        position: absolute;
        right: -10px;
        top: 0px;
        border-right: 10px solid rgba(0,0,0,0);
        border-top: 5px solid rgba(0,0,0,0);
        border-left: 10px solid #63ce7f;
        border-bottom: 5px solid rgba(0,0,0,0);
        transition: border-left-color .5s;
      }
    }
    .san1{
      transform: rotate(-160deg);
    }
    .san2{
      transform: rotate(-116deg);
      &::after{
         border-left-color: #ffdf64;
      }
    }
    .san3{
      transform: rotate(-70deg);
      &::after{
         border-left-color: #f78927;
      }
    }
    .san4{
      transform: rotate(-25deg);
      &::after{
         border-left-color: #fa6362;
      }
    }
  }
  .fraction-qr{
    text-align: center;
    font-size: 16px;
    color: #2979ff;
    margin: 0 30px;
    padding-top: 20px;
    margin-bottom: 80px;
    .pic{
      margin: 20px 0;
      width: 250px;
    }
    p:first-child{
      text-align: left;
    }
  }
  .bom-btn{
    position: fixed;
    bottom: 30px;
    width: calc(100% - 30px);
  }
  .page-btn{
    position: fixed;
    right: 0;
    bottom: 80px;
    img{
      width: 80px;
      height: auto;
    }
  }
}
</style>
